// Contract between SideNav's two chat buttons and whoever hosts the drawers.
//
//   SideNav   ──chat-open {kind}──▶   host opens the matching drawer
//   host      ──chat-unread n────▶    SideNav shows the badge
//
// Ported from SwiftProcessingSPA's helpers/chatLauncher.js. One difference: over there the
// drawers live on the dashboard route, so the rail had to navigate home first and the host
// consumed a "pending" intent in mounted(). Here the drawer is hosted globally in App.vue and
// is mounted on every route, so there is nothing to navigate to and no pending state to keep —
// the event always lands on a live listener.

import bus from "@/helpers/appBus.js"

export const CHAT_OPEN_EVENT = "chat-open"
export const CHAT_UNREAD_EVENT = "chat-unread"
export const CHAT_KIND_SWIFT = "swiftchat"
export const CHAT_KIND_LOANLAUNCH = "loanlaunch"

export function requestOpenChat(kind) {
  bus.emit(CHAT_OPEN_EVENT, kind)
}

export function onChatOpen(handler) {
  bus.on(CHAT_OPEN_EVENT, handler)
}

export function offChatOpen(handler) {
  bus.off(CHAT_OPEN_EVENT, handler)
}

export function publishChatUnread(n) {
  bus.emit(CHAT_UNREAD_EVENT, Number(n) || 0)
}

export function onChatUnread(handler) {
  bus.on(CHAT_UNREAD_EVENT, handler)
}

export function offChatUnread(handler) {
  bus.off(CHAT_UNREAD_EVENT, handler)
}
